// extracted by mini-css-extract-plugin
module.exports = {"Container":"RemixesSection_Container___HU8C"};